var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26482 0.967203C9.84141 0.0114069 11.0888 -0.287406 12.0359 0.303388L81.719 43.772C82.6553 44.356 82.9416 45.5879 82.3589 46.525L82.1225 46.9052L88.817 51.2038C89.712 51.7785 90.0006 52.9531 89.4739 53.8772L85.7421 60.4242C85.1804 61.4096 83.9125 61.7312 82.949 61.1326L75.9717 56.7971L75.5254 57.5149C74.9638 58.4182 73.7934 58.7239 72.8618 58.2105L60.6776 51.4968L73.0664 76.4046C73.5583 77.3936 73.1554 78.5941 72.1664 79.086L69.928 80.1993C68.939 80.6912 67.7385 80.2883 67.2466 79.2993L50.6771 45.9864L43.3155 41.93L24.5173 80.0197C24.0284 81.0102 22.8292 81.4169 21.8387 80.928L19.5968 79.8216C18.6063 79.3328 18.1996 78.1335 18.6885 77.143L37.6168 38.7899L1.03516 18.6328C0.0408229 18.0849 -0.298579 16.8201 0.287857 15.848L9.26482 0.967203Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discover_icon.4924c588660b817692e2a66aeebb31ed.svg";
export { ForwardRef as ReactComponent };